import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import './SmapDrawerSkeleton.css';

const SmapDrawerSkeleton: React.FC = () => {
  return (
    <div className="smap-drawer smap-drawer--skeleton">
      {/* Header Skeleton */}
      <header className="smap-drawer__header">
        <div className="smap-drawer__header-content">
          <div className="smap-drawer__title-container">
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="text" width={150} height={20} />
          </div>
          <div className="smap-drawer__actions">
            <Skeleton variant="circular" width={32} height={32} />
            <Skeleton variant="circular" width={32} height={32} />
          </div>
        </div>
      </header>

      {/* Form Body Skeleton */}
      <div className="smap-drawer__content">
        <div className="smap-drawer__form-container">
          <div className="space-y-6">
            {/* Name Input Skeleton */}
            <div className="smap-drawer__input-group">
              <Skeleton variant="text" width={100} height={20} className="mb-2" />
              <Skeleton variant="rectangular" width="100%" height={45} className="rounded-lg" />
            </div>

            {/* Description Skeleton */}
            <div className="smap-drawer__input-group">
              <Skeleton variant="text" width={120} height={20} className="mb-2" />
              <Skeleton variant="rectangular" width="100%" height={150} className="rounded-lg" />
            </div>

            {/* Tabs Skeleton */}
            <div className="smap-drawer__tabs-wrapper border-b border-light-border dark:border-hover-dark">
              <Box className="flex gap-8 mb-2">
                <Skeleton variant="text" width={80} height={30} />
                <Skeleton variant="text" width={100} height={30} />
                <Skeleton variant="text" width={80} height={30} />
              </Box>
            </div>

            {/* List items skeleton */}
            <div className="space-y-4 mt-6">
                <Skeleton variant="rectangular" width="100%" height={60} className="rounded-xl" />
                <Skeleton variant="rectangular" width="100%" height={60} className="rounded-xl" />
                <Skeleton variant="rectangular" width="100%" height={60} className="rounded-xl" />
            </div>
          </div>
        </div>
      </div>

      {/* Footer Skeleton */}
      <footer className="smap-drawer__footer">
        <Skeleton variant="rectangular" width={100} height={40} className="rounded-lg" />
        <Skeleton variant="rectangular" width={120} height={40} className="ml-auto rounded-lg" />
      </footer>
    </div>
  );
};

export default SmapDrawerSkeleton;
